export * from './post-info.component';
